import { HTMLAttributes } from "react";
import { useHistory } from "react-router-dom";

import axios from "axios";

// トークンチェック間隔: 5min(x60sec x1000ms)
const intervalMs = 5 * 60 * 1000;

export function checkSize(e: any) {
  const file = e.item(0);
  if (file === null) {
    return;
  }
  if (file.size > 10485760) {
    return "10MB以上の画像は添付できません";
  }
  return;
}

export async function convertFileToBase64(files: any) {
  if (files === null) {
    return;
  }
  const file = files.item(0);
  if (file === null) {
    return;
  }
  var reader = new FileReader();
  const promise = new Promise((resolve, reject) => {
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
  });

  reader.readAsDataURL(file);
  return promise;
}

// クエリからtokenを取得
const searched = /token=([^&]+)/.exec(window.location.search)

let token = searched ? searched[1] : null

// 送信前共通処理
axios.interceptors.request.use((request) => {
  if (token)
    request.headers["Authorization"] = `Bearer ${token}`
  return request;
});

// トークン更新
function recreateToken() {
  if (!token) {
    clearInterval(intervalId);
    return // トークンなしなら実施しない
  }
  axios
    .post("/api/v1/sp/app/token", { token })
    .then((result) => {
      token = result.data.token;
    })
    .catch((e) => {
      window.location.href = "/errors/400"
      clearInterval(intervalId);
    });
}

export const intervalId = setInterval(recreateToken, intervalMs);
recreateToken()

// アプリ内表示のためのトークン保持
export const AppAuthUtil = (props: HTMLAttributes<any>) => {
  const history = useHistory();

  // tokenがない場合はリクエスト不正
  token || history.push("/errors/400")

  return <>
    {props.children}
  </>
}